"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavPillPanel = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _KeyboardDetectionContext = require("../../contexts/KeyboardDetectionContext.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
var _excluded = ["active", "role", "tabIndex", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var NavPillPanelContainer = _styledComponents["default"].div.withConfig({
  displayName: "NavPillPanel__NavPillPanelContainer",
  componentId: "sc-3yvzv-0"
})(["", ";"], function (props) {
  return (0, _styledComponents.css)(["color:", ";&:focus{", "}"], (0, _index.cssColorValue)(_index.semanticColors.textBase), !props.$isUsingKeyboard ? 'outline: none;' : null);
});

/**
 * @deprecated
 * This component will be archived soon.
 * Use the TabsPanel component instead.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-navpill-navpillpanel--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavPillPanel)
 */
var NavPillPanel = exports.NavPillPanel = /*#__PURE__*/_react["default"].forwardRef(function NavPillPanel(_ref, ref) {
  var active = _ref.active,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'tabpanel' : _ref$role,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_KeyboardDetectionContext.KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  return /*#__PURE__*/_react["default"].createElement(NavPillPanelContainer, Object.assign({
    ref: ref,
    role: role,
    hidden: active,
    tabIndex: tabIndex,
    $isUsingKeyboard: isUsingKeyboard
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.NavPillPanel
  }), children);
});